import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47557242"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "title", "aria-pressed"]

import { computed } from "vue";
import { useStore } from "vuex";
import { SunIcon, MoonIcon } from "@heroicons/vue/outline";
import { AuthGetters } from "@/store/modules/auth";
import { canUseDarkTheme, currentTheme, setTheme } from "@/utils/theme";
import { t } from "@/i18n";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const store = useStore();
const identity = computed(() => store.getters[AuthGetters.GET_USER_IDENTITY]);
const allowed = computed(() => canUseDarkTheme(identity.value));
const label = computed(() => t(currentTheme.value === "dark" ? "theme.light" : "theme.dark"));
function toggle() { setTheme(identity.value, currentTheme.value === "dark" ? "light" : "dark"); }

return (_ctx: any,_cache: any) => {
  return (_unref(allowed))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "theme-toggle",
        "aria-label": _unref(label),
        title: _unref(label),
        "aria-pressed": _unref(currentTheme) === 'dark',
        onClick: toggle
      }, [
        (_unref(currentTheme) === 'dark')
          ? (_openBlock(), _createBlock(_unref(SunIcon), {
              key: 0,
              "aria-hidden": "true"
            }))
          : (_openBlock(), _createBlock(_unref(MoonIcon), {
              key: 1,
              "aria-hidden": "true"
            }))
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})